export function addZeros(string) {
    return String(string).padStart(2, '0');
}

export function convertDateToIso(date) {
    if(!date || date === '') return '';

    const arr = date.split('/');

    return `${arr[2]}-${arr[1]}-${arr[0]}`
}

export function convertDateFromIso(date) {
    if(!date || date === '') return '';

    const arr = date.split('-');

    return `${arr[2]}/${arr[1]}/${arr[0]}`
}



// WEBPACK FOOTER //
// ./src/composables/functions.js